import * as React from 'react';
import { CircleStatus } from '../case-administration/container-phase/CircleStatus';
import { Typography } from '@/components/common';
import { StepStatusCaseType } from '@/interfaces';
import { format, parseISO } from 'date-fns';

interface CasePhaseHeaderProps {
	title: string;
	status: StepStatusCaseType;
	position: string;
	completedStepDate?: string;
}

export const CasePhaseHeader: React.FC<CasePhaseHeaderProps> = ({
	status,
	title,
	position,
	completedStepDate,
}) => {
	return (
		<div className="flex items-center gap-x-[18px] mb-[18px]">
			<CircleStatus status={status} position={position} />
			<div>
				<Typography type="semibold-16" className="text-black">
					{title}
				</Typography>
				{completedStepDate && (
					<Typography type="regular-12" className="text-left text-green-60">
						{`Completed on ${format(
							parseISO(completedStepDate),
							'MMM dd, yyyy'
						)}`}
					</Typography>
				)}
			</div>
		</div>
	);
};
